import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BookedLessonByChild } from 'src/app/classes/BookedLessonByChild';
import { BookedLessonBySubscription } from 'src/app/classes/BookedLessonBySubscription';
import { environment } from 'src/environments/environment';
import { Page } from '../../classes/Page';
import { User } from '../../classes/User';
import { Language } from '../../enums/Language';
import { Payment } from 'src/app/classes/PaimentReport';
import { PaymentReportFilters } from 'src/app/enums/PaymentReportFilters';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpClient: HttpClient) {}

  public getRoles(): Observable<string[]> {
    return this.httpClient.get<string[]>(
      `${environment.backendApiUrl}/v1/users/roles`,
      httpOptions
    );
  }

  public getCurrentUser(): Observable<User> {
    return this.httpClient.get<User>(
      `${environment.backendApiUrl}/v1/users/current`,
      httpOptions
    );
  }

  public setUserLanguage(language: Language): Observable<void> {
    return this.httpClient.post<void>(
      `${environment.backendApiUrl}/v1/users/language`,
      { language },
      httpOptions
    );
  }

  public getAllUsers(
    page: number,
    size: number,
    roles = [],
    withSubscriptions = false
  ): Observable<Page<User>> {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('size', size);
    roles.forEach((role) => {
      params = params.append('roles', role);
    });
    params = params.append('withSubscription', withSubscriptions);
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params,
    };
    return this.httpClient.get<Page<User>>(
      `${environment.backendApiUrl}/v1/users`,
      options
    );
  }

  public deleteUser(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      `${environment.backendApiUrl}/v1/users/` + id,
      httpOptions
    );
  }

  public addOrEdit(editedUser: User): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.backendApiUrl}/v1/users`,
      editedUser,
      httpOptions
    );
  }

  public qrInfo(id: number): Observable<Blob> {
    return this.httpClient.get(
      `${environment.backendApiUrl}/v1/users/` + id + '/qr',
      { responseType: 'blob' }
    );
  }

  public getUserBookedLessonsBySubscriptionId(
    subscriptionId: number,
    size: number
  ): Observable<BookedLessonBySubscription> {
    return this.httpClient.get<BookedLessonBySubscription>(
      `${environment.backendApiUrl}/v1/lessons-booking/purchased-subscriptions/${subscriptionId}?page=0&size=${size}`,
      httpOptions
    );
  }

  public getUserBookedLessonsByChildId(
    childId: number,
    size: number
  ): Observable<BookedLessonByChild> {
    return this.httpClient.get<BookedLessonByChild>(
      `${environment.backendApiUrl}/v1/lessons-booking/child/${childId}?page=0&size=${size}`,
      httpOptions
    );
  }

  getPaymentsHistory(
    page: number,
    size: number,
    filters: PaymentReportFilters,
    sort: {column: string, direction: string}
  ): Observable<Page<Payment>> {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('size', size);
    if (sort && sort.column && sort.direction && sort.column !== '' && sort.direction !== '') {
      params = params.append('sort', `${sort.column},${sort.direction}`);
    }
    return this.httpClient.post<Page<Payment>>(
      `${environment.backendApiUrl}/v1/admin/orders/payment-report`,
      {...filters},
      {...httpOptions, params}
    );
  }
}
